import setHighestPriorityPackage from "./setHighestPriorityPackage"
import getAvailability from "./getAvailability"
import getPrice from "./getPrice"
import getWiypPrice from "./getWiypPrice"
import getLanguageFromLocale from "./getLanguageFromLocale"
import getSiteFromDomain from "./getSiteFromDomain"
import {wiypFeature} from "@/config/ABTestFeatures"
import { wiypActive } from '@/config/ABTestExperiments';
import { wiypCookie } from "@/config/ABTestExperimentConfig"

// Logic
import isABTestActive from "@/logic/isABTestActive"


import Cookies from "js-cookie"


const searchPrestationsForFilter = async (storeObj: any) => {
    const { state, commit, dispatch } = storeObj;
    if (state.productUnavailable) return;

    try {
        dispatch("setLoading", true);
        commit("setQuoteRequestsFinishedLoading", false);

        // Asynchronously fetch availability data
        const availabilityPromise = getAvailability(
            state.packCode,
            state.dates.BeginDate,
            state.dates.EndDate,
            storeObj
        );

        
        // Wait for availability data to resolve
        const availabilityResponse = await availabilityPromise;

        // Handle price requests based on AB testing conditions
        handlePriceRequests(state, storeObj);

        dispatch("setLoading", false);

        // Check package availability and adjust if necessary
        const isPackageFromHashAvailable = availabilityResponse?.availablePackages?.some(
            (packageObj) => packageObj.codePackage === state.packCode
        );

        if (availabilityResponse && !isPackageFromHashAvailable) {
            setHighestPriorityPackage(storeObj);
        }
    } catch (error) {
        console.error("Error handling prestation search:", error);
        dispatch("setLoading", false); // Ensure loading is set to false on error
    }
}


// Helper function to format dates from "MM/DD/YYYY" to "YYYY-MM-DD"
function formatDates(date: string): string {
    return date.split('/').reverse().join('-');
}

// Main function to handle price requests based on cookie settings
async function handlePriceRequests(state: any, storeObj: any) {
    if (state.packCode === "HS" || !state.dates.BeginDate || !state.dates.EndDate) {
        console.error("cannot")
        return;
    }

    const beginDate = formatDates(state.dates.BeginDate);
    const endDate = formatDates(state.dates.EndDate);

    // If the AB test variant is set, call getWiypPrice
    // Use cookies for the ab test
    const isActive = Cookies.get(wiypCookie) === 'active'
    if (isActive) {
        if (state.prestMaps && state.prestMaps.seAvailabilities && state.prestMaps.seAvailabilities[state.packCode]) {
            const prestIds = Object.keys(state.prestMaps.seAvailabilities[state.packCode])
                .map(key => state.prestMaps.seAvailabilities[state.packCode][key].prestIdSource)
                .sort((a, b) => a - b)
                .join("-");

            const sortedParticipants = state.participants.slice().sort((a: number, b: number) => b - a).join('-');

            await getWiypPrice(
                state.packageId,
                state.packCode,
                state.liheData.id,					
                prestIds,
                beginDate,
                endDate,
                sortedParticipants,
                getSiteFromDomain(new URL(window.location.href).hostname),
                getLanguageFromLocale(state.language),
                storeObj
            );
        }
    } else {
        // If AB test cookie is not set, call getPrice
        await getPrice(state.packCode, beginDate, endDate, storeObj);
    }
}

export default searchPrestationsForFilter